import { useContext, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Context from "./Context"
import { formatarTempo } from "./utils"

export default function NewNote(){
    const {id:idRota,num:numStr,texto:textoRaw}=useParams()
    const {setNotas,notas,setId,id,tempo,setTempo}=useContext(Context)
    const navigate=useNavigate()
    useEffect(()=>{
        const num=parseInt(numStr)
        const texto=textoRaw.replaceAll('-',' ')
        setId(idRota)
        setTempo(num)
        const minutos=formatarTempo(num)
        let cria=true
        for(let nota of notas){
            if(nota.id==idRota&&nota.num==num)cria=false
        }
        if(cria)setNotas([...notas,{
            id:idRota,
            texto,
            num,
            minutos
        }])
    },[])
    useEffect(()=>{
        if(!id||!tempo)return
        navigate('/')
    },[id])
    return <></>
}